@if (incomeTaxEntity$ | async; as incomeTaxEntity) {
  <form [formGroup]="formGroup">
    @if (prestatiebeursTerugBetaald.length > 0) {
      <div formArrayName="prestatiebeursTerugBetaald">
        @for (item of prestatiebeursTerugBetaald.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Studiejaar' : ''"
                                              [options]="incomeTaxEntity.year !==  2025 ? onderwijsJaar : onderwijsJaar2025"
                                              [required]=true
                                              class="col-auto custom-input-250"
                                              formControlName="onderwijsJaar"
                                              id="onderwijsJaar-{{i}}"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-select-form-control [disabledControl]="isMboDisabled(i)"
                                              [label]="i === 0 ? 'Mbo' : ''"
                                              [options]="optionsJaNee"
                                              [required]=true
                                              class="col-auto custom-input-150"
                                              formControlName="mbo"
                                              id="mbo-{{i}}"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-select-form-control [disabledControl]="isHboDisabled(i)"
                                              [label]="i === 0 ? 'Hbo/Wo' : ''"
                                              [options]="optionsJaNee"
                                              class="col-auto custom-input-150"
                                              formControlName="hboWo"
                                              id="mbo-{{i}}"
            >
            </snelstart-ui-select-form-control>
            <div class="row col-auto" formGroupName="periodeWaaroverTerugbetaaldMoetWordenInMaanden"
                 style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Van' : ''"
                                              class="custom-input-150"
                                              formControlName="begindatum"
                                              id="begindatum-{{i}}"
              >
              </snelstart-ui-date-form-control>
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Tot en met' : ''"
                                              class="custom-input-150"
                                              formControlName="einddatum"
                                              id="einddatum-{{i}}"
              >
              </snelstart-ui-date-form-control>
            </div>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [disabledControl]="isHboAndMboDisabled(i)"
                                              [label]="i === 0 ? 'Terugbetaald bedrag' : ''"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="terugbetaaldeBedrag"
                                              id="terugbetaaldeBedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Terugbetaalde prestatiebeurs
  </snelstart-ui-button>
}

